import { z } from 'zod';

export const PlaceLikeResponse = z.object({
  likeCount: z.number().int(),
  isLikedByMe: z.boolean(),
});
export type PlaceLikeResponse = z.infer<typeof PlaceLikeResponse>;
